module.exports = "/fonts/Lato-Bold.woff?89b618086a797a8be0f4549489bb2993";